import React, { useRef, useState, useEffect } from 'react';
import classnames from "classnames";
import { Label, Input } from "reactstrap";

function CustomRadioCheck({ color = "primary", text, name, id, value, checked, onChange }) {
  return (
    <Label className={`w-100 m-0 py-2 d-flex align-items-center justify-content-center gap-1
    form-check form-radio-${color} form-check-inline border rounded cursor-pointer ` +
      (checked ? `border-${color} text-${color}` : `border-dark border-opacity-25 text-body`)
    }>
      <Input className='form-check-input mt-0' type='radio' name={name} value={value} checked={checked} onChange={onChange} />
      {text}
    </Label>
  )
}

export default CustomRadioCheck
